import React from "react"
import { Flex } from "antd"
import PropTypes from "prop-types"
import AssignedEquipmentSection from "./components/AssignedEquipmentSection"
import AvailableEquipmentSection from "./components/AvailableEquipmentSection"
import useEquipmentManagement from "./hooks/useEquipmentManagement"

const EquipmentTab = ({ booking }) => {
  const {
    assignedEquipment,
    filteredAvailableEquipment,
    showAddEquipment,
    selectedCategories,
    categoryOptions,
    handleUnassign,
    handleAssign,
    handleCategoryFilter,
    toggleAddEquipment,
    closeAddEquipment,
    fetchLoading,
    assignLoading,
    unassignLoading
  } = useEquipmentManagement(booking?.id)

  const canEdit = booking?.can_edit

  return (
    <Flex vertical gap={24} className="w-full">
      <AssignedEquipmentSection
        equipment={assignedEquipment}
        onUnassign={handleUnassign}
        onToggleAdd={toggleAddEquipment}
        canEdit={canEdit}
        fetchLoading={fetchLoading}
        unassignLoading={unassignLoading}
        showAddEquipment={showAddEquipment}
      />

      {showAddEquipment && (
        <AvailableEquipmentSection
          equipment={filteredAvailableEquipment}
          selectedCategories={selectedCategories}
          onAssign={handleAssign}
          onCategoryChange={handleCategoryFilter}
          onClose={closeAddEquipment}
          categoryOptions={categoryOptions}
          canEdit={canEdit}
          assignLoading={assignLoading}
        />
      )}
    </Flex>
  )
}

EquipmentTab.propTypes = {
  booking: PropTypes.shape({
    id: PropTypes.number,
    can_edit: PropTypes.bool
  })
}

export default EquipmentTab
